import apiCalls from "@/mixins/apiCalls.js";
const APP_ACTION = false;

export default {
  mixins: [apiCalls],
  methods: {
    async fetchCallerIds() {
      // console.log('fetch fetchCallerIds ', this.user.profile.domain_user_id, this.user);
      this.loaded = false;
      const functionName = "get_caller_ids";
      const reqBody = {
        fake: false,
        domain_user_id: this.user.profile.domain_user_id, //account.domain_user_id,
      };
      const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
      if (data.error_code === 200) {
        this.defaultClId = data.data.default_clid;
        this.callerIds = data.data.items;
        // this.loaded = true; // debug
      }
    },
    async fetchUserDIDs() {
      this.loaded = false; //debug
      // console.log('fetch this.user.domain_user_id dids ', this.user.profile.domain_user_id, this.user);
      const functionName = "get_dids";
      const reqBody = {
        domain_user_id: this.user.profile.domain_user_id,
        fake: false,
        page: 0,
      };
      const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
      // console.log('data ', data);
      if (data.error_code === 200) {
        this.displayItems = data.data;
        this.itemsList;
        return;
      }
    },
  },
};
